import { processCashReport } from "./processCashReport";
import { processSessions } from "./processSessions";

/**
* Processes daily transactions and updates the cash register.
* @param {string} dateKey - Date in YYYY-MM-DD format
*/
async function processDay(dateKey) {
  try {
    const amountRemoved = await processSessions(dateKey);
    await processCashReport(dateKey, amountRemoved);
  } catch (error) {
    console.error('processDay error:', error.message);
  }
}

export {processDay };